// @ts-check

const commonHeaderProps = {
  numeric: false,
  disablePadding: true,
  display: true,
  useLink: false,
  useTooltip: false,
  useMark: false,
};

// table 的 headers
export const headers = {
  id: {
    label: "id", // 用於 EnhancedTableHead
    id: "id", // 用於 EnhancedTableHead
    ...commonHeaderProps,
  },
  label: {
    label: "名稱", // 用於 EnhancedTableHead
    id: "label", // 用於 EnhancedTableHead
    ...commonHeaderProps,
  },
  value: {
    label: "值", // 用於 EnhancedTableHead
    id: "value", // 用於 EnhancedTableHead
    ...commonHeaderProps,
  },
};
